import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '@app/core/services/common.service';

export interface IAlertPopup {
  title: string;
  description?: string;
  isConfirmBox?: boolean;
  btnCaption?: btnCaptionEnum,
  rejectBtnCaption?: RejectbtnCaptionEnum;
  isRejectBtn?: boolean;
  isLoader?: boolean;
  image?: string;
  isHtml?: boolean;
  isSvgString?: boolean;
  isRemember?: boolean;
  isWarn?: boolean;
  hideClose?: boolean;
}

export enum btnCaptionEnum {
  delete = 'Delete',
  accept = 'Accept',
  yes = 'Yes',
  proceed = 'Proceed',
  reattemp = 'Reattempt',
  retry = 'Retry',
  refresh = 'Refresh',
  unmute = 'Unmute'
}

export enum RejectbtnCaptionEnum {
  no = 'No',
  close = 'Close',
  cancel = 'Cancel',
  dismiss = 'Dismiss',
  stayMute = 'Stay Muted',
}

@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss']
})


export class AlertPopupComponent implements OnInit {

  constructor(public readonly dialogRef: MatDialogRef<AlertPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public alertO: IAlertPopup,
    private readonly commonService: CommonService) {
  }

  ngOnInit(): void { }

  closeDailog(val: boolean) {
    this.dialogRef.close(val);
  }

  dontWarn() {
    this.commonService.setLocalStorage('dontShowStopPopup', true)
  }


}
